import { Card, CardContent } from "@aurumiq/ui/components/card";
import { CheckIcon } from "lucide-react";
import { PageHeader } from "@/app/page-header";
import { QueryState } from "@/components/query-state";
import { useRoles } from "@/features/staff/queries";

function granted(perms: string[], perm: string): boolean {
  if (perms.includes("*") || perms.includes(perm)) return true;
  return perms.includes(`${perm.split(":")[0]}:*`);
}

export function RolesPage() {
  const roles = useRoles();
  return (
    <>
      <PageHeader
        title="Roles"
        description="Which permissions each staff role grants. Roles are fixed in the API; this matrix is read-only."
      />
      <Card className="overflow-x-auto p-0">
        <CardContent>
          <QueryState query={roles} rows={6}>
            {(r) => (
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b text-left text-muted-foreground text-xs uppercase">
                    <th className="px-3 py-2 font-semibold">Permission</th>
                    {r.roles.map((role) => (
                      <th key={role.role} className="px-3 py-2 text-center font-semibold">
                        {role.role}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {r.permissions.map((perm) => (
                    <tr key={perm} className="border-b last:border-0 hover:bg-muted/50">
                      <td className="px-3 py-1.5 font-mono text-xs">{perm}</td>
                      {r.roles.map((role) => {
                        const ok = granted(role.permissions, perm);
                        return (
                          <td key={role.role} className="px-3 py-1.5 text-center">
                            {ok ? (
                              <CheckIcon
                                className="inline size-4 text-success"
                                aria-label={`${role.role} has ${perm}`}
                              />
                            ) : (
                              <span className="text-muted-foreground/40">
                                <span className="sr-only">{`${role.role} lacks ${perm}`}</span>
                                <span aria-hidden="true">—</span>
                              </span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </QueryState>
        </CardContent>
      </Card>
    </>
  );
}
